import axios from 'axios';

export const countryApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/country`,
    headers: {
        'Content-Type': 'application/json'
    }
})